import React, { useMemo } from "react";
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    createColumnHelper,
} from "@tanstack/react-table";

const Drivertraining = ({ data = [] }) => {
    const tableData = useMemo(() => data.result || [], [data]);

    const columnHelper = createColumnHelper();
    const columns = useMemo(
        () => [
            columnHelper.accessor("DRIVER_NAME", {
                header: "Driver Name",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("TRAINING_DATE", {
                header: "Training Date",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("TRAINING_HAPPENED_AT", {
                header: "Training Location",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("TRAINING_GIVEN", {
                header: "Training Given",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("OWNER_NAME", {
                header: "Owner Name",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("CHASSIS_NO", {
                header: "Chassis Number",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("PL", {
                header: "PL",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("CONDUCTED_BY", {
                header: "Conducted By",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("MOBILE_NO", {
                header: "Mobile Number",
                cell: info => info.getValue(),
            }),
            columnHelper.accessor("DEALER_CODE", {
                header: "Dealer Code",
                cell: info => info.getValue(),
            }),
        ],
        [columnHelper]
    );

    const table = useReactTable({
        data: tableData,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-3 text-[#2374BF]">
                Driver Training Report
            </h2>
            <table className="min-w-full border border-blue-300 rounded-md overflow-hidden">
                <thead className="bg-[#2374BF] text-white">
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th
                                    key={header.id}
                                    className="px-4 py-2 border-b border-blue-300 text-left font-medium"
                                >
                                    {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map((row, rowIndex) => (
                        <tr
                            key={row.id}
                            className={`${rowIndex % 2 === 0 ? "bg-white" : "bg-blue-50"
                                } hover:bg-blue-100`}
                        >
                            {row.getVisibleCells().map(cell => (
                                <td
                                    key={cell.id}
                                    className="px-4 py-2 border-b border-blue-200 text-gray-700"
                                >
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Drivertraining;
